module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.ff615c95.ttf";